import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { CircularProgress, styled, TableCell, TableRow } from '@mui/material'
import { AddOutlined, Check } from '@mui/icons-material'
import { Button, Typography } from '@carto/meridian-ds/components'
import { Integration } from 'features/integrations/types'

interface IntegrationsTableRowProps {
  integration: Integration
  loading?: boolean
  addNewUri: string
  actions?: React.ReactNode
}

const ThumbnailCell = styled(TableCell)(({ theme }) => ({
  '& > div': {
    padding: 0,
    width: theme.spacing(5)
  }
}))

function IntegrationsTableRow({ integration, addNewUri, loading, actions }: IntegrationsTableRowProps) {
  return (
    <TableRow aria-label={`integration - ${integration.title}`}>
      <ThumbnailCell width={58}>{integration.icon}</ThumbnailCell>
      <TableCell>
        <Typography variant="body2" color="textPrimary" weight="strong">
          {integration.title}
        </Typography>
        <Typography variant="caption" color="textSecondary" weight="regular">
          {integration.description}
        </Typography>
      </TableCell>
      <TableCell width={120}>
        {loading ? (
          <CircularProgress color="primary" size={20} />
        ) : integration.id ? (
          <Typography variant="body2" color="textSecondary" display="flex" alignItems="center" gap={1}>
            <Check fontSize="small" />
            <FormattedMessage id="common.button.added" />
          </Typography>
        ) : (
          <Button
            role="button"
            component={Link}
            startIcon={<AddOutlined />}
            variant="outlined"
            to={addNewUri}
            color="primary"
          >
            <FormattedMessage id="common.button.add" />
          </Button>
        )}
      </TableCell>
      <TableCell width={36} align="right">
        {integration.id && actions}
      </TableCell>
    </TableRow>
  )
}

export default IntegrationsTableRow
